import { parseJSONString, setNonceToElement } from '@pes-ui/utils';
const waitForElementLoad = (el) => new Promise((res) => {
  el.addEventListener('load', res, { once: true });
});
const sourcesCache = new Map();
export const appendScSources = (el, scriptScUrl, styleScUrl) => {
  return Promise.all([{ scriptScUrl }, { styleScUrl }].map(({ scriptScUrl, styleScUrl }) => {
    const url = scriptScUrl || styleScUrl;
    const isCached = sourcesCache.has(url);
    let childElement = null;
    if (scriptScUrl && !isCached) {
      childElement = document.createElement('script');
      childElement.src = scriptScUrl;
    }
    if (styleScUrl && !isCached) {
      childElement = document.createElement('link');
      childElement.rel = 'stylesheet';
      childElement.type = 'text/css';
      childElement.href = styleScUrl;
    }
    if (!isCached && childElement) {
      setNonceToElement(childElement);
      el.appendChild(childElement);
      const loadPromise = waitForElementLoad(childElement);
      sourcesCache.set(url, loadPromise);
      return loadPromise;
    }
    return sourcesCache.get(url);
  }));
};
class Selector {
  constructor() {
    this.inited = false;
  }
  async init(config) {
    if (!this.inited) {
      await appendScSources(document.body, config.scConfiguratorUrlJS, config.scConfiguratorUrlCSS);
      this.inited = true;
    }
    return this;
  }
  open(config) {
    var _a, _b, _c;
    if (this.inited) {
      if (this.widget) {
        this.widget.destroy();
      }
      let startWidget;
      const functionalIds = config.scFunctionalIds && parseJSONString(config.scFunctionalIds, null);
      if (!functionalIds) {
        startWidget = (_a = window === null || window === void 0 ? void 0 : window.seWidgetWrapper) === null || _a === void 0 ? void 0 : _a.startHierarchy;
      }
      else {
        startWidget = Array.isArray(functionalIds)
          ? (_b = window.seWidgetWrapper) === null || _b === void 0 ? void 0 : _b.loadConfigModelByFunctionalIds
          : (_c = window.seWidgetWrapper) === null || _c === void 0 ? void 0 : _c.startWidget;
      }
      this.widget = startWidget(functionalIds || config.scDataset, config.scLanguage, config.scCountry, config.scProject, config.scToken, config.scOptions);
      this.widget.addSaveConfigurationListener((rest) => {
        document.dispatchEvent(new CustomEvent('scSelectorAddToCart', { detail: rest }));
      });
    }
    else {
      console.error("Can't open widget, selector is not inited");
    }
    return this;
  }
}
export const ScProductSelector = new Selector();
